import { render, staticRenderFns } from "./ResumeTemplate.vue?vue&type=template&id=3534c41f&"
import script from "./ResumeTemplate.vue?vue&type=script&lang=js&"
export * from "./ResumeTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ResumeTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports